import { AdministrationHelper } from "@/Administration/Helpers/AdministrationHelper";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { LocalizedTextDto } from "@/Common/Models/LocalizedTextDto";
import { SiteCreateState } from "../../SiteCreate";

interface ISiteDescriptionSubSectionProps {
    localizedDescription: LocalizedTextDto;
    mutateState: (mutation: (state: SiteCreateState) => void, then?: () => void) => void;
}

function SiteDescriptionSubSection(props: ISiteDescriptionSubSectionProps): JSX.Element {
    const { getText } = useTranslation();
    const { localizedDescription, mutateState } = props;

    const onChangeHandle = (value: string, propertyName: string): void => {
        mutateState(s => s.localizedDescription = {
            ...localizedDescription,
            [propertyName]: value
        });
    };

    return (
        <>
            <div className="view-subsection-header row">
                <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                    <h4 className="view-subsection-title">{getText("ClinicInfo_SiteDescriptionLabel")}</h4>
                </div>
            </div>

            <div className="view-subsection-body">
                {AdministrationHelper.getLocalizedTextSiteCreateArray(localizedDescription).map((item, index) => (
                    <div key={`description_${index}`} className="row" style={{ marginBottom: "15px" }}>
                        <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                            <label className="form-label">{item.languageName}</label>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-6 form-field-answer">
                            <textarea
                                className="form-control"
                                value={item.value}
                                maxLength={AdministrationHelper.maxNoteLengthLimit}
                                onChange={e => {
                                    if (e.target.value.length > AdministrationHelper.maxNoteLengthLimit) {
                                        return;
                                    }
                                    onChangeHandle(e.target.value, item.propertyName);
                                }}
                            />
                            <label data-cy="counter-label">
                                {`${item.value?.length ?? 0}/${AdministrationHelper.maxNoteLengthLimit}`}
                            </label>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}

export { ISiteDescriptionSubSectionProps };
export default SiteDescriptionSubSection;
